<template>
  <div class="container mescroll-touch">
    <div ref="generateImageBox" class="generateImageBox">
      <!-- <img class="cover" src="@/assets/images/PersonalPoster_cover.jpg" alt="" /> -->
      <img class="cover" src="@/assets/images/PersonalPoster_bg.png" alt="" />
      <div class="personalInfo">
        <div class="userInfo">
          <img class="touxiang" src="@/assets/images/headSculpture1.png" alt="" />
          <div class="info">
            <span class="name">{{ personalInfo.UserName }}</span>
            <span class="positionalName" v-if="personalInfo.PositionalName">{{ personalInfo.PositionalName }}</span>
          </div>
        </div>
        <div class="hospital">
          <img src="@/assets/images/hospital@2x.png" alt="" />
          <span>{{ personalInfo.HospitalTitle }}</span>
        </div>
        <div class="hospital">
          <img src="@/assets/images/keshi@2x.png" alt="" />
          <span>{{ personalInfo.SubjectName }}</span>
        </div>
        <div class="dataBox">
          <div class="dataItem">
            <span class="dataNum">{{ personalInfo.FansCount }}</span>
            <span class="dataName" v-if="userInfo.Type != 3">粉丝</span>
            <span class="dataName" v-if="userInfo.Type == 3">Followers</span>
          </div>
          <div class="dataItem">
            <span class="dataNum">{{ personalInfo.AttentionCount }}</span>
            <span class="dataName" v-if="userInfo.Type != 3">关注</span>
            <span class="dataName" v-if="userInfo.Type == 3">Following</span>
          </div>
          <div class="dataItem">
            <span class="dataNum">{{ personalInfo.LikeAndCollectCount }}</span>
            <span class="dataName" v-if="userInfo.Type != 3">获赞与收藏</span>
            <span class="dataName" v-if="userInfo.Type == 3">Favorites</span>
          </div>
        </div>
        <div class="example">
          <img class="picture_icon" src="@/assets/images/picture_icon.png" alt="" />
          <span v-if="userInfo.Type != 3">长按保存图片<br/>到相册</span>
          <span v-if="userInfo.Type == 3">Save to<br/>photos</span>
          <img class="arrow_icon" src="@/assets/images/arrow_icon.png" alt="" />
          <img class="qrcode_icon" :src="QRcode" alt="" />
          <span v-if="userInfo.Type != 3">微信扫码立刻查看<br/>我的学术内容</span>
          <span v-if="userInfo.Type == 3">Scan to<br/>follow</span>
        </div>
      </div>
    </div>
    <img class="PosterPhoto" v-if="PosterPhoto" :src="PosterPhoto" alt="" />
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { mapState } from "vuex";
export default {
  name: 'FansFollowList',
  data() {
    return {
      personalInfo: {},
      PosterPhoto: '',
      QRcode: ''
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.getUserInfo();
    this.toast = this.$toast.loading({
      message: '生成中...',
      forbidClick: true,
    });
  },
  methods: {
    getUserInfo() {
      this.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
        id: this.userInfo.Id
      }).then(res => {
        this.personalInfo = res.Data;
        this.getQRcode();
      })
    },
    getQRcode() {
      this.$axios.post('/Api/Api/Web/Customer/CreateQR', {
        uid: this.userInfo.Id,
        type: this.$route.query.type
      }).then(res => {
        if(res.Data) {
          this.QRcode = res.Data;
          this.$nextTick(() => {
            this.generateImage();
          })
        } else {
          this.$toast('二维码获取失败');
        }
      })
    },
    generateImage() {
      html2canvas(this.$refs.generateImageBox, {
        useCORS: true
      }).then((canvas) => {
        this.PosterPhoto = canvas.toDataURL("image/png");
        this.toast.clear();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  height: 100%;
  .generateImageBox {
    // height: 100%;
    // background-image: url("../../assets/images/PersonalPoster_bg.png");
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    border-radius: 22px;
    overflow: hidden;
  }
  .cover {
    display: block;
    width: 100%;
  }
  .personalInfo {
    position: absolute;
    top: 28%;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    color: #564C47;
    .userInfo {
      position: relative;
      margin-bottom: 20px;
      .touxiang {
        position: absolute;
        top: -55px;
        display: block;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
      }
      .info {
        height: 34px;
        margin-left: 100px;
        margin-top: 10px;
        .name {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 3px;
        }
        .positionalName {
          font-size: 12px;
          align-items: center;
          background-color: #EAEAEA;
          padding: 1px 2px;
          margin-left: 10px;
        }
      }
    }
    .hospital {
      display: flex;
      align-items: center;
      margin: 8px 0;
      img {
        display: block;
        width: 14px;
        margin-right: 8px;
        flex-shrink:0;
      }
      span {
        font-size: 15px;
        color: #564C47;
      }
    }
    .dataBox {
      display: flex;
      padding: 10px 0 20px;
      background-image: linear-gradient(to right, #8C3BBB 0%, #C33BBB 50%, #EB1700 100%);
      background-size: 100% 1px;
      background-position: 0 100%;
      background-repeat: no-repeat;
      .dataItem {
        flex: 1;
        text-align: center;
        .dataNum {
          display: block;
          font-size: 16px;
          font-weight: bold;
          color: #030303;
        }
        .dataName {
          display: block;
          font-size: 12px;
          color: #564C47;
        }
      }
    }
    .example {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0px 0;
      font-size: 12px;
      .picture_icon {
        display: block;
        width: 60px;
      }
      .arrow_icon {
        display: block;
        width: 25px;
        // margin: 0 5px;
      }
      .qrcode_icon {
        display: block;
        width: 60px;
      }
    }
  }
  .PosterPhoto {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 100%;
  }
}
</style>